<template>
    <div>
        <transition-group
            tag="div"
            class="row flex-nowrap overflow-visible"
            name="animation-class"
            @after-leave="inTransition = false"
        >
            <div
                class="col-12"
                :key="currentQuestion.index"
            >
                <div class="row justify-content-center">
                    <div class="col-sm-6 mb-3">
                        <button
                            class="hover-invert p-4 choice"
                            @click="respond(-1)"
                        >
                            {{ currentQuestion.left }}
                        </button>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <button
                            class="hover-invert p-4 choice"
                            @click="respond(1)"
                        >
                            {{ currentQuestion.right }}
                        </button>
                    </div>
                </div>
            </div>
        </transition-group>
        <div class="text-center">
            <div
                class="btn btn-secondary d-sm-inline-block d-block mb-5 mt-0 mb-sm-4 mt-sm-5"
                @click="respond(0)"
            >
                Spring over
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "TestQuestion",
    computed: {
        ...mapGetters([
            'currentQuestion'
        ]),
    },
    methods: {
        respond(value) {
            if (this.inTransition) { return; }
            this.inTransition = true;

            let question = this.currentQuestion;
            return this.$store.dispatch('questionResponse', {
                qindex: question.index,
                response: value,
            });
        },
    },
    data() {
        return {
            inTransition: false,
        };
    },
};
</script>
